const fetchAs = require("./fetchAs");

module.exports = async function fetchCategories(rels, dispatch = null) {
    let categories = [];

    for (let rel of rels) {
        if (rel && typeof rel.type === 'string' && rel.id && rel.id !== 'missing') {
            let type = rel.type.split("--");
            let endpoint = `${type[0]}/${type[1]}/${rel.id}`;
            let _cat = await fetchAs({ endpoint, dispatch });

            if (_cat && _cat.data && _cat.data.attributes) {
                categories.push({
                    id: _cat.data.id,
                    type: _cat.data.type,
                    name: _cat.data.attributes.name,
                });
            }
        }
    }

    return categories.length > 0 ? categories : null;
};
